import { render, staticRenderFns } from "./plateInput.vue?vue&type=template&id=ac7f1f70&scoped=true&"
import script from "./plateInput.vue?vue&type=script&lang=js&"
export * from "./plateInput.vue?vue&type=script&lang=js&"
import style0 from "./plateInput.vue?vue&type=style&index=0&id=ac7f1f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7f1f70",
  null
  
)

component.options.__file = "plateInput.vue"
export default component.exports